export default "__VITE_ASSET__DzUeikV3__"